const AbiFeeFormulaApiUrls = {
  LIST: `${process.env.REACT_APP_USER_ABI_URL}/abi/fee-formula/list`,
  CREATE: `${process.env.REACT_APP_USER_ABI_URL}/abi/fee-formula/create`,
  UPDATE: `${process.env.REACT_APP_USER_ABI_URL}/abi/fee-formula/update`,
  DELETE: `${process.env.REACT_APP_USER_ABI_URL}/abi/fee-formula/delete`,
}

export default AbiFeeFormulaApiUrls
